module.exports = __webpack_public_path__ + "static/media/06jiechuwanggong2.3a0c1b37.png";